import { render, staticRenderFns } from "./skip-nav.vue?vue&type=template&id=50080a0c&"
import script from "./skip-nav.vue?vue&type=script&lang=js&"
export * from "./skip-nav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports